/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Trash2, Download, RefreshCw, Search, Mail } from 'lucide-react';
import { useAdmin } from './AdminAuth';

const SignupsPanel = () => {
  const { authAxios } = useAdmin();
  const [signups, setSignups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const res = await authAxios.get('/signups');
      setSignups(res.data);
    } catch (e) { /* handled by interceptor */ }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm('Delete this signup?')) return;
    await authAxios.delete(`/signups/${id}`);
    setSignups((prev) => prev.filter((s) => s.id !== id));
  };

  const exportCsv = () => {
    const rows = [['email', 'source', 'created_at'], ...filtered.map((s) => [s.email, s.source, s.created_at])];
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'flix-signups.csv'; a.click();
    URL.revokeObjectURL(url);
  };

  const filtered = signups.filter((s) => s.email.toLowerCase().includes(query.toLowerCase()));

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <div>
          <h2 className="font-display text-2xl font-700 text-[#0f1712]">Email sign-ups</h2>
          <p className="text-[#0f1712]/50 text-sm mt-1">{signups.length} total • people who clicked “Get FLIX”</p>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={load} className="inline-flex items-center gap-2 rounded-xl border border-[#0f1712]/15 px-4 py-2.5 text-sm font-semibold text-[#0f1712] hover:border-[#0e9f6e] transition-colors">
            <RefreshCw size={15} /> Refresh
          </button>
          <button onClick={exportCsv} className="inline-flex items-center gap-2 rounded-xl bg-[#0e9f6e] text-white px-4 py-2.5 text-sm font-semibold hover:bg-[#0c8a60] transition-colors">
            <Download size={15} /> Export CSV
          </button>
        </div>
      </div>

      <div className="relative mb-4 max-w-sm">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#0f1712]/40" />
        <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search by email…"
          className="w-full rounded-xl border border-[#0f1712]/15 pl-9 pr-4 py-2.5 text-sm outline-none focus:border-[#0e9f6e] transition" />
      </div>

      <div className="rounded-2xl border border-[#0f1712]/10 overflow-hidden bg-white">
        {loading ? (
          <div className="p-10 text-center text-[#0f1712]/40 text-sm">Loading…</div>
        ) : filtered.length === 0 ? (
          <div className="p-12 text-center">
            <Mail size={28} className="mx-auto text-[#0f1712]/25 mb-3" />
            <p className="text-[#0f1712]/50 text-sm">No sign-ups yet.</p>
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-[#f6f6f2] text-[#0f1712]/50 text-xs uppercase tracking-wide">
              <tr>
                <th className="text-left px-5 py-3 font-semibold">Email</th>
                <th className="text-left px-5 py-3 font-semibold">Source</th>
                <th className="text-left px-5 py-3 font-semibold">Date</th>
                <th className="px-5 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((s) => (
                <tr key={s.id} className="border-t border-[#0f1712]/8 hover:bg-[#f6f6f2]/60">
                  <td className="px-5 py-3.5 text-[#0f1712] font-medium">{s.email}</td>
                  <td className="px-5 py-3.5 text-[#0f1712]/60">{s.source}</td>
                  <td className="px-5 py-3.5 text-[#0f1712]/60">{new Date(s.created_at).toLocaleString()}</td>
                  <td className="px-5 py-3.5 text-right">
                    <button onClick={() => remove(s.id)} className="text-[#0f1712]/40 hover:text-red-500 transition-colors">
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default SignupsPanel;
